import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconDefault from './icons/IconDefault';
import IconFront from './icons/IconFront';
import IconInRoom from './icons/IconInRoom';
import IconSide from './icons/IconSide';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import { black, green } from '../../Constants/Colors';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import InRoomView from '../InRoomView/InRoomView';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: 1,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      left: 0,
      bottom: 15,
      width: '100%',
      justifyContent: 'space-evenly',
    },
  },
  icon: {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    justifyContent: 'center',
    margin: '0 12px',
    height: 50,
    color: green,
    transition: 'color 0.3s ease-in-out',
    '&:hover': {
      color: black,
    },
    [theme.breakpoints.down('sm')]: {
      margin: '4px 0',
    },
  },
}));

export const CameraViewToolbar = () => {
  const classes = useStyles();
  const [inRoomOpen, setInRoomOpen] = useState(false);

  const createClickHandler = (view) => () => Services.visualization.setView(view);

  return (
    <div className={classes.root}>
      <Tooltip title={t('inRoom.entryTooltip')}>
        <div className={classes.icon} onClick={() => setInRoomOpen(true)}>
          <IconInRoom />
        </div>
      </Tooltip>
      <div className={classes.icon} onClick={createClickHandler('default')}>
        <IconDefault />
      </div>
      <div className={classes.icon} onClick={createClickHandler('side')}>
        <IconSide />
      </div>
      <div className={classes.icon} onClick={createClickHandler('front')}>
        <IconFront />
      </div>
      <InRoomView open={inRoomOpen} onClose={() => setInRoomOpen(false)} />
    </div>
  );
};

export default CameraViewToolbar;
